import { IconInfoSquareRounded } from '@tabler/icons-react'
import { Trans, useTranslation } from 'react-i18next'

import { Link } from 'src/components/Link/Link'
import { Text } from 'src/components/Text/Text'

import styles from './ProductAccordion.module.scss'

export const GearReturnsElement = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text variant="p">
        <Trans i18nKey="pdp.accordion.gear.returns.text" />
      </Text>
      <div className={styles.linkContainer}>
        {[1, 2, 3].map((n) => (
          <div className={styles.linkRow} key={n}>
            <IconInfoSquareRounded stroke={1.6} />
            <Link
              href={t(`pdp.accordion.gear.returns.link0${n}.link`)}
              target="_blank"
              aria-label={`${t(`pdp.accordion.gear.returns.link0${n}.text`)} - ${t('common.newTab')}`}
            >
              {t(`pdp.accordion.gear.returns.link0${n}.text`)}
            </Link>
          </div>
        ))}
      </div>
    </>
  )
}
